import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    formControl: {
        width: '70%',
        padding: '20px 0',
        textAlign: 'left',
        '& legend': {
            position: 'relative',
            top: 20,
            marginBottom: 10,
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            padding: '10px 0'
        }
    },
    flexRow: {
        display: 'flex', 
        flexDirection: 'row', 
        flexWrap: 'wrap'
    }
}));

export const CheckBoxInput = ({ label, options, onChange, defaultValue, ...restProps }) => {
    const classes = useStyles();
    const [checked, setChecked] = useState([]);

    const handleCheck = (event) => {
        const { value } = event.target;
        setChecked(checked.includes(value) ? checked.filter(c => c !== value) : [...checked, value]);
    };

    useEffect(() => {
        onChange({ target: { name: restProps.name, value: checked.toString() } })
    }, [checked])

    useEffect(()=> {
        if (defaultValue) {
            setChecked(defaultValue.split(','))
        }
    }, [])

    return (
        <div className={classes.root}>
            <FormControl {...restProps} component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">{label}</FormLabel>
                <FormGroup className={classes.flexRow}>
                    {options && options.length && options.map((option) => {
                        return (<FormControlLabel
                            control={<Checkbox onChange={handleCheck} checked={checked.includes(option.value)} value={option.value} />}
                            label={option.key}
                        />)
                    })}
                </FormGroup>
            </FormControl>

        </div>
    )
}
